import React from "react";
import {TextToSpeachIcon} from "@hugeicons/core-free-icons";
import {MiniCard} from "./MiniCard";
import {useDashboard} from "../../../../context/DashboardContext";

export const TextToSpeechCard = () => {
    const {responseTime} = useDashboard();

    const avgSynthesize = (
        responseTime?.filter(i => +i?.avgSynthesize > 0)
            ?.map(i => +i?.avgSynthesize)
            ?.reduce((prev, next) => prev + next, 0) /
        responseTime?.filter(i => +i?.avgSynthesize > 0)?.length
    )?.toFixed(2) || 0;

    const chartData = responseTime?.map(i => ({
        ...i,
        dateCreated: i?.hour,
        duration: i?.avgSynthesize?.toFixed(2)
    }));
    const transcribeLabel = avgSynthesize != null && !isNaN(avgSynthesize)
        ? `${Number(avgSynthesize).toFixed(2)}s`
        : "-";
    const hasActivity = chartData?.some(d => Number(d.duration) > 0);


    return (
        <MiniCard
            icon={TextToSpeachIcon}
            color={"#dd9230"}
            title={transcribeLabel}
            subtitle={"TEXT TO SPEECH"}
            data={chartData}
            hideChart={!hasActivity}
        />
    );
};
